import React, { useState, useRef, useEffect } from 'react';
import { Toaster } from 'sonner';
import { CartProvider } from './context/CartContext';
import { captureAttribution } from './lib/attribution';
import { Hero } from './components/Hero';
import { HandsOnSection } from './components/sections/HandsOnSection';
import { BigCatsSection } from './components/sections/BigCatsSection';
import { ExtraordinarySection } from './components/sections/ExtraordinarySection';
import { PettingZooSection } from './components/sections/PettingZooSection';
import { PropsSection } from './components/sections/PropsSection';
import { CTASection } from './components/sections/CTASection';
import { CartDrawer } from './components/CartDrawer';
import { FloatingCart } from './components/FloatingCart';
import { EstimateForm } from './components/EstimateForm';
import './App.css';

function HomePage() {
  const [showEstimateForm, setShowEstimateForm] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => { captureAttribution(); }, []);

  const scrollToContent = () => {
    contentRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCheckout = () => {
    setShowEstimateForm(true);
  };

  return (
    <div className="min-h-screen bg-background" data-testid="home-page">
      <Hero onBeginBooking={scrollToContent} />

      <div ref={contentRef}>
        <HandsOnSection />
        <BigCatsSection />
        <ExtraordinarySection />
        <PettingZooSection />
        <PropsSection />
        <CTASection />
      </div>

      <footer className="py-12 px-6 border-t border-white/10 bg-background">
        <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-gold mb-2">
              Exotic Animals Miami
            </p>
            <p className="text-white/30 text-sm">
              Private Exotic Animal Experiences
            </p>
          </div>
          <div className="text-center md:text-right">
            <p className="text-white/30 text-sm">
              &copy; {new Date().getFullYear()} Exotic Animals Miami. All rights reserved.
            </p>
            <p className="text-white/20 text-xs mt-1">
              Private. Professional. Unforgettable.
            </p>
          </div>
        </div>
      </footer>

      <CartDrawer onCheckout={handleCheckout} />
      <FloatingCart />
      <EstimateForm 
        isOpen={showEstimateForm} 
        onClose={() => setShowEstimateForm(false)} 
      />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#121212',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
          },
        }}
      />
      <HomePage />
    </CartProvider>
  );
}

export default App;
